// test1189
(1189 && 0);
